var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 14,
    viewBox: "0 0 17 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Twitter logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 1.59312C16.3746 1.86339 15.7023 2.04597 14.9969 2.12811C15.7169 1.70764 16.27 1.04182 16.5304 0.24841C15.8564 0.63783 15.11 0.920516 14.3155 1.07287C13.6794 0.412523 12.7729 0 11.7698 0C9.84367 0 8.28196 1.52117 8.28196 3.39748C8.28196 3.66377 8.31282 3.92311 8.37232 4.17177C5.47364 4.03009 2.90375 2.67742 1.18351 0.621848C0.883293 1.12363 0.711252 1.70723 0.711252 2.3299C0.711252 3.50868 1.32699 4.5486 2.26284 5.15786C1.69113 5.14022 1.15334 4.98737 0.683117 4.73292C0.682721 4.74708 0.682721 4.76132 0.682721 4.77564C0.682721 6.42176 1.88496 7.79488 3.4805 8.10721C3.18785 8.18488 2.87972 8.22636 2.56165 8.22636C2.33691 8.22636 2.11846 8.205 1.90545 8.16542C2.34932 9.51519 3.63733 10.4975 5.16359 10.5248C3.96993 11.4361 2.46611 11.9793 0.831982 11.9793C0.550461 11.9793 0.272851 11.9632 0 11.9318C1.54352 12.8959 3.3768 13.4583 5.34642 13.4583C11.7616 13.4583 15.2698 8.28126 15.2698 3.79137C15.2698 3.64406 15.2664 3.49758 15.2597 3.35177C15.9411 2.87284 16.5324 2.27451 16.9999 1.59312H17Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.e7bf98de.svg";
export { ForwardRef as ReactComponent };